<div class="flex align-items-center gap-2">
  <i [class]="icon"></i>
  <span>{{ label }}</span>
</div>
